/* eslint-disable react/prop-types */ // TODO: add props
import { SelectDropdown } from 'edrolo-style-guide';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import { useSchools } from './hooks';
import styles from './SchoolSelector.scss';

const SchoolSelector = ({
  selected,
  onChange,
  controlId,
  disabled = false,
  required = false,
}) => {
  const { schools, schoolsError, schoolsLoading } = useSchools();

  const options = schools
    ?.sort((a, b) => a.name - b.name)
    ?.map(({ id, name }) => ({
      value: id,
      label: `(id: ${id}) ${name}`,
    }));

  const selectedSchoolOption =
    options?.find((option) => option.value === selected) || null;

  return (
    <>
      {schoolsLoading && <LoadingIndicator loadingText="Loading schools..." />}

      {schools && !schoolsError && !schoolsLoading && (
        <SelectDropdown
          options={options}
          value={selectedSchoolOption}
          placeholder={'Select a school'}
          onChange={(option) => onChange(option ? option : null)}
          controlId={controlId}
          className={styles.schoolSelect}
          isDisabled={disabled && selectedSchoolOption}
          // TODO: Upgrade to `react-select-5` because `isRequired` is not supported in `react-select-4`!!!
          isRequired={required}
        />
      )}
    </>
  );
};

export default SchoolSelector;
